<template>
  <div class="solution">
    <div class="banner">
      <div class="title">社交媒体营销</div>
      <div class="desc">
        <section>基于对社交媒体环境的洞察与创意营销的基因，擅长为广告主提供策略咨询、创意策划、</section>
        <section>技术开发、数据挖掘、媒体采买等优质服务</section>
      </div>
      <router-link target="_blank"  to='/contact'><div class="button">立即体验<i class="el-icon-right"></i></div></router-link>
    </div>
    <div class="context">
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>social营销环境复杂，内容需求量大，内容生产周期不可把控，效率低，成本高，交付</section>
            <section>慢</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">全案策划：</span>10余年social 经验为品牌提供从策略咨询、创意策划、数据挖掘、技术开发到</section>
            <section>媒介采买的一站式专业服务</section>
            <section><span>创意热店：</span>8大创意服务类型以及150+创意服务形式，为品牌提供多元优质的内容创意</section>
            <section>供给</section>
            <section><span>数字化交付：</span>区别于传统的交付方式，以创意服务+内容中台的形式为品牌提供数字化</section>
            <section>的交付，帮助品牌实现内容营销的数字化升级</section>
          </div>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/marketing/1.png">
      </div>
      <div class="row drak">
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/marketing/2.png">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>海量social媒体质量参差不齐，时常遭遇选号盲区，人工沟通投放效率低，反馈慢</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">智能选号：</span>依拖kolstore，为品牌投放提供智能账号推荐、智能搜索、智能报价单、账</section>
            <section>号数据分析等多维度服务</section>
            <section><span>智能投放：</span>依托平台智能锁定头部KOL的价格、排期、意愿，电话直联及在线沟通等工</section>
            <section>具保障沟通及时高效</section>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>social 环境多平台，跨渠道的内容分散度极高，内容管理难度大，投放前中后期的全链</section>
            <section>路数据追踪难以把控</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">内容管理：</span>帮助品牌搭建内容中台，通过内容标签及分类的形式高效管理海量创意资</section>
            <section>源，方便查找及复用</section>
            <section><span>创意热店：</span>8大创意服务类型以及150+创意服务形式，为品牌提供多元优质的内容创意</section>
            <section>供给</section>
            <section><span>数据全链路监测：</span>自研新媒体大数据平台kolrank，汇聚超过500万+自媒体数据样本，</section>
            <section>数据全面覆盖包括微信、微博、bilibili、抖音、快手、小红书等主流社媒平台。面向品牌</section>
            <section>客户提供KOL分析、粉丝画像分析、投放去水评估、品牌声量分析等多种营销数据服务</section>
          </div>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/marketing/3.png">
      </div>
    </div>
     <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/solutionBanner.vue'
export default {
  name: 'marketing',
  components: {
    banner,
  },
}
</script>
<style lang="scss" scoped>
.solution{
    width: 100%;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .banner{
      text-align: center;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/solution/marketing/banner.png');
      width: 100%;
      min-width: 1400px;
      height: 460px;
     background-size: cover;
      background-position-x: center;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 54px;
      }

    }
    .context{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 1400px;
      .drak{
        background: #F7F7F9;
      }
      .row{
          padding-top: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding-bottom: 115px;
        .left{
          margin-left: 142px;
        }
        .right{
          margin-right: 142px;
        }
        .introduce{
          .iheader{
            display: flex;
            align-items: center;
            img{
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }
            .iTitle{
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;

              .bold{
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 33px;
              }
              .thin{
               font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 22px;
              }
            }
          }
          .idesc{
            margin-top: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 24px;
            margin-bottom: 32px;
            .marginTop16{
              margin-top: 16px;
            }
            .marginTop{
              margin-top: 0;
            }
            span{
              display: inline-block;
              color: #3B3946;
              font-weight: 600;
              margin-top: 16px;
            }
            .title{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 28px;
                margin-bottom: 16px;
                margin-top: 32px;
                position: relative;
                &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(255, 167, 126, 0) 0%, #FF6E48 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                  left: -16px;
                }
            }
            .purple{
              &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(90, 45, 245, 0) 0%, #5A2DF5 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                  left: -16px;
                }
            }
          }
        }
        .img{
          width: 595px;
        }

      }
    }

     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
          .el-icon-right{
            display: none;
            margin-left: 8px;
          }
        &:hover{
          .el-icon-right{
            display: block;
            margin-left: 8px;
            color: #FFFFFF;
          }
        }
      }
}
</style>
